export default "__VITE_ASSET__D0TDuW56__"